import { GetSSE, Post, SSEOptions } from "domain/infra/data/api";
import DomainConstants from "../../infra/data/domainConstants";
import { UsuarioResponse } from "../../types/usuario/usuarioResponse";

export class AuthenticationService {// extends ExemploService {
  constructor() {
    //super()
  }

  async LoginByToken(token: string): Promise<UsuarioResponse | Error> {
    //token = encodeURIComponent(token)
    return await Post(DomainConstants.apiDomain.authentication.loginByToken, { token: token })
  }

  async LogOut(usuarioID: number): Promise<string | Error> {
    return await Post(DomainConstants.apiDomain.authentication.logOut, { usuarioID: usuarioID })
  }

  //TODO REMOVER
  async TestSSE<T, SSET>(data : string, dispatchName : string, options : SSEOptions<SSET>): Promise<T | Error> {
    return await GetSSE<T, SSET>(`${DomainConstants.apiDomain.authentication.testSSE}?request=${data}`, dispatchName, options)
  }
}
